import { render, staticRenderFns } from "./SaiquApplyList.vue?vue&type=template&id=9b0c915e&"
import script from "./SaiquApplyList.vue?vue&type=script&lang=js&"
export * from "./SaiquApplyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports